var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22222 15.3334H20.7778C21.45 15.3334 22 14.7834 22 14.1111C22 13.4389 21.45 12.8889 20.7778 12.8889H1.22222C0.55 12.8889 0 13.4389 0 14.1111C0 14.7834 0.55 15.3334 1.22222 15.3334ZM1.22222 9.22224H20.7778C21.45 9.22224 22 8.67224 22 8.00002C22 7.3278 21.45 6.7778 20.7778 6.7778H1.22222C0.55 6.7778 0 7.3278 0 8.00002C0 8.67224 0.55 9.22224 1.22222 9.22224ZM0 1.88891C0 2.56113 0.55 3.11113 1.22222 3.11113H20.7778C21.45 3.11113 22 2.56113 22 1.88891C22 1.21669 21.45 0.666687 20.7778 0.666687H1.22222C0.55 0.666687 0 1.21669 0 1.88891Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.7c7b2b84276e2c42d6841d17257b5c69.svg";
export { ForwardRef as ReactComponent };